import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function QuoteBand() {
  return (
    <section className="bg-white pb-20 md:pb-28" data-testid="quote-band">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grain relative overflow-hidden bg-brand-accent px-8 md:px-14 py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div
            className="absolute inset-0 opacity-[0.10] bg-cover bg-center"
            style={{ backgroundImage: "url(/images/apps/celik-konstruksiyon.jpg)" }}
          />
          <div className="absolute inset-0 blueprint opacity-70" />
          <div className="relative">
            <div className="eyebrow text-white/55">Teklif Talebi</div>
            <p className="mt-4 font-display text-xl md:text-[1.7rem] font-light text-white tracking-[-0.03em] leading-snug max-w-xl">
              Özel projeleriniz için mühendislik ekibimizden teklif alın.
            </p>
          </div>
          <Link
            to="/teklif-iste"
            data-testid="quote-band-btn"
            className="relative group font-mono text-[11px] uppercase tracking-[0.18em] bg-white text-brand-accent hover:bg-brand-ink hover:text-white pl-6 pr-3.5 py-3.5 rounded-full flex items-center gap-3 whitespace-nowrap transition-colors duration-300"
          >
            Teklif İste
            <span className="w-7 h-7 rounded-full bg-brand-accent/10 group-hover:bg-white/15 flex items-center justify-center transition-[transform,background-color] duration-300 group-hover:rotate-45">
              <ArrowUpRight className="w-3.5 h-3.5" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
